import { axios } from '@/utils/request'

const api = {
  enterprise: '/enterprise/management'
}

export function selectFindAll (parameter) {
  return axios({
    url: '/system/dict/data/findAll',
    method: 'get',
    params: parameter
  })
}

export function getEnterpriseList (parameter) {
  return axios({
    url: api.enterprise + '/list',
    method: 'get',
    params: parameter
  })
}

export function managementRecordList (parameter) {
  return axios({
    url: '/enterprise/management/recordList',
    method: 'get',
    params: parameter
  })
}

export function customInfoGet (parameter) {
  return axios({
    url: 'enterprise/customInfo/get',
    method: 'get',
    params: parameter
  })
}

export function customInfoSave (parameter) {
  return axios({
    url: 'enterprise/customInfo/save',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function saveEnterprise (parameter) {
  return axios({
    url: api.enterprise + (parameter.enterpriseId > 0 ? '/update' : '/save'),
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function addEnterprise (parameter) {
  return axios({
    url: api.enterprise + '/add',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getEnterpriseDetail (parameter) {
  return axios({
    url: api.enterprise + '/get',
    method: 'get',
    params: parameter
  })
}

export function updateEnterprise (parameter) {
  return axios({
    url: api.enterprise + '/update',
    method: 'POST',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function getEnterpriseModel (parameter) {
  return axios({
    url: api.enterprise + '/model/' + parameter,
    method: 'get'
  })
}

// // 企业配置型号
// export function configModel2 (parameter) {
//   return axios({
//     url: api.enterprise + '/selectEnterpriseModelTree',
//     method: 'POST',
//     data: parameter,
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8'
//     }
//   })
// }

// 企业配置型号
export function configModel (parameter) {
  return axios({
    url: api.enterprise + '/selectAllModel',
    method: 'POST',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 省
export function getselectAllProvince (parameter) {
  return axios({
    url: '/basicdata/province/selectAllProvince',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 市
export function getselectCityName (parameter) {
  return axios({
    url: '/basicdata/city/selectCityName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 区
export function getselectAreaName (parameter) {
  return axios({
    url: '/basicdata/area/selectAreaName',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 企业禁用
export function enterpriseListDisable (parameter) {
  return axios({
    url: api.enterprise + '/disable',
    method: 'post',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 企业启用
export function enterpriseListEnable (parameter) {
  return axios({
    url: api.enterprise + '/enable',
    method: 'post',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

// 企业黑名单
export function enterpriseListPullblack (parameter) {
  return axios({
    url: api.enterprise + '/remove',
    method: 'post',
    params: parameter
  })
}

// 企业恢复
export function enterpriseListresume (parameter) {
  return axios({
    url: api.enterprise + '/resume',
    method: 'post',
    params: parameter
  })
}

// 导出企业
export function exportEnterprise (parameter) {
  return axios({
    url: api.enterprise + '/export',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
}

// 设置市场负责人
export function updateMarketPrincipal (parameter) {
  return axios({
    url: api.enterprise + '/market/principal',
    method: 'post',
    params: parameter
  })
}

// 企业信息查询
export function enterpriseQuery (parameter) {
  return axios({
    url: '/enterprise/query/list',
    method: 'get',
    params: parameter
  })
}

export const enterpriseExport = api.enterprise + '/export'
